import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ApiResponse } from '../models';
import {
  FeatureSettings,
  SettingsData,
} from '../interfaces/settings.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Settings {
  private readonly baseUrl: string = environment.apiUrl;
  constructor(private readonly httpClient: HttpClient) {}

  getFeatureSettings() {
    return this.httpClient.get<ApiResponse<SettingsData<FeatureSettings>>>(
      `${this.baseUrl}/viewer/settings/featureSettings`,
      { headers: { Authorization: `Basic SmF6ek11c2ljQDEyMw==` } }
    );
  }

  getAppEnabledLanguages(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.baseUrl}/viewer/appEnabledLanguages`
    );
  }
}
